<template>
  <v-row class="pa-2" no-gutters>
    <custom-popup
      v-model="ready"
      :cons="{ title: 'نمونه کارت ویزیت های آماده' }"
      hide-confirm
      hide-overlay
      max-width="900"
      transition="dialog-bottom-transition"
    >
      <v-card class="p-5" flat>
        <prepared-cards
          v-model="cardTexts"
          :close-modal="
            () => {
              this.ready = false;
            }
          "
          type="visitCard"
        />
      </v-card>
    </custom-popup>

    <v-col
      class="pa-2 sticky-md"
      cols="12"
      md="4"
      style="top: 110px; height: fit-content"
    >
      <component
        :is="theme"
        v-model="cardTexts"
        :data="cardTexts"
        :orders.sync="orders"
      />
    </v-col>

    <v-col class="pa-2 px-0" cols="12" md="8">
      <template>
        <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
          <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
            <div class="row justify-center">
              <div class="col-md-12">
                <p>وارد کردن اطلاعات کارت ویزیت</p>
              </div>
              <div class="col-md-6 mt-0 pt-0">
                <v-text-field
                  v-model="cardTexts.visitName"
                  :disabled="e6 > 1"
                  append-icon="mdi-pen"
                  class="mt-0 pt-0"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  label="نام کارت ویزیت شما"
                  outlined
                />
              </div>
            </div>
          </v-stepper-step>

          <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
            <v-btn
              :disabled="e6 > 1"
              class="mb-4"
              color="third"
              outlined
              @click="clearDefaults"
            >
              <v-icon class="me-2">mdi-delete</v-icon>
              حذف اطلاعات پیشفرض
            </v-btn>

            <v-btn class="float-end btn-download" @click="ready = true">
              انتخاب کارت ویزیت آماده
            </v-btn>

            <list-expansion
              flat
              icon="pencil-ruler"
              single
              title="انتخاب طرح قالب"
            >
              <template v-slot:content>
                <theme-selector v-model="theme" :components="customTheme" />
              </template>
            </list-expansion>
            <list-expansion :components="specialInfo" :data="cardTexts" flat />
            <qr-generator ref="qrGenerator" v-model="cardTexts" />

            <div class="col-md-12">
              <next-btn
                :loading="loading"
                style="background: #1b8d39"
                @click="markQr(false)"
              />
            </div>
          </v-stepper-content>
        </v-stepper>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import MobileViwer from "../../pages/qrland/components/mobileViwer";
import QrGenerator from "../../pages/qrland/components/qrGenerator";
import QrMaker from "../../pages/qrland/components/qrMaker";
import { Bus } from "@/main";
import QrCustomize from "../../pages/qrland/components/qrCustomize";
import DownloadFile from "../../pages/qrland/downloadFile";
import QrManagement from "../../pages/qrland/components/qrManage/qrManagement";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import QrAddressField from "../../content/fragments/qrAddressField";
import VisitThemeTwo from "../../pages/qrland/components/themes/visitThemeTwo";
import ThemeSelector from "../../pages/qrland/components/themes/themeSelector";
import VisitThemeFlipped from "@/view/pages/qrland/components/themes/visitThemeFlipped";
import PreparedCards from "@/view/pages/qrland/preparedCards";

export default {
  name: "createModel",

  components: {
    PreparedCards,
    ThemeSelector,
    VisitThemeTwo,
    VisitThemeFlipped,
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrManagement,
    DownloadFile,
    QrCustomize,
    QrMaker,
    QrGenerator,
    MobileViwer,
  },

  data() {
    return {
      theme: "MobileViwer",
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      orders: [],
      createdId: null,
      shortId: null,
      finish: true,
      loading: false,
      showDialog: false,
      customTheme: [
        { name: "MobileViwer", value: "" },
        { name: "VisitThemeTwo", value: "" },
        { name: "VisitThemeFlipped", value: "" },
      ],
      specialInfo: [
        {
          name: "textCards",
          value: "",
          title: "اطلاعات کاربری",
          subtitle: "",
          icon: "account-outline",
        },
      ],
      headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
      bodyColors: "",
      eyeStyle: "",
      qrStyle: "",
      qrSize: "",
      dtUrl: null,
      destination: "",
      cardTexts: {
        pallete: {},
        visitName: "کارت ویزیت",
        isGradient: false,
        organizationName: "ترمینال تبلیغات",
        subOrgan: "مدیریت همزمان ۴۰ روش تبلیغاتی!",
        userName: "خانم خوانساری",
        workField: "پشتیبانی",
        phoneNumber: [{ number: "90007425" }],
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        companyNumber: "02191017077",
        email: "info@terminalads.com",
        fax: "02191016066",
        location:
          "تهران، خیابان شریعتی ، بعد از پل سید خندان، بن بست خندان ، پلاک 6 ",
        city: "",
        photo: {
          gallery: [
            {
              name: "",
              images: [],
            },
          ],
          headBackground: "/media/business/faq/faq-1.webp",
          profile: "",
          transition: "scale",
          hasWelcome: false,
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
        codePostal: "1541946815",
        province: "",
        country: "",
        website: "",
        socialMedia: {},
        aboutUs:
          "تنها سامانه جامع بررسی و مدیریت تبلیغات آنلاین\n" +
          "\n" +
          "سامانه ترمینال تبلیغات مفتخر است تا از رهگذر ارتباط مداوم و تاثیرگذار با مشتریان و مخاطبان خود از نیازهای آنها آگاه گردیده و بهترین راهکارها را در اختیارشان قرار دهد.\n" +
          "\n" +
          "سامانه ترمینال تبلیغات بزرگترین و مهمترین سرمایه خود را مشتریان و کاربران وفادار می داند و در درجه دوم تیم متخصص و کارآمد که با ایده های جدید و فناوری های نوین شرکت را یاری می کنند.",
        video_single: {
          name: "",
          videos: [],
        },
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: "",
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      },
      qrShow: 1,
      ready: false,
      svgMade: "",
      destinationUrl: "",
    };
  },
  computed: {
    defaultProfileImage() {
      return (
        this.$coreApi3 + "/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png"
      );
    },
    defaultWebsite() {
      return this.$coreqrApi || "https://qr.terminalads.com";
    },
  },

  mounted() {
    this.cardTexts.photo.profile = this.defaultProfileImage;
    this.cardTexts.website = this.defaultWebsite;
    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    this.qrDesign = {
      qrStyleColors: {
        backcolor: "",
        frontColor: "",
        gradient_color: "",
        gradient: false,
        pattern: "default",
      },
      MarkerCenter: {
        topRight: "",
        bottomLeft: "",
        main: "",
        different_markers_color: false,
        eyePattern: "default",
      },
      QrMarkOut: {
        topRight: "",
        bottomLeft: "",
        markOutPattern: "default",
        main: "",
        different_markers_color: false,
      },
      QrFrame: {
        main: "",
        text: "SCAN ME",
        framePattern: "none",
        different_markers_color: false,
      },
      LogoImg: { noBg: false, logoSize: 100, logoImg: "none" },
    };

    Bus.$on("colorPalette", (value) => {
      this.cardTexts.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.cardTexts.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.cardTexts.isGradient = value;
    });

    Bus.$on("eyeStyle", (value) => {
      this.eyeStyle = value;
    });

    Bus.$on("qrStyle", (value) => {
      this.qrStyle = value;
    });
  },

  methods: {
    markQr(final = false) {
      this.loading = true;
      let obj = {
        type: "VisitCard",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        data: JSON.stringify({
          theme: this.theme,
          data: this.cardTexts,
          orders: this.orders,
        }),
        qr: {
          section: "#link",
          link: "https://qr2.in/",
          backcolor: "#ffffff",
          frontcolor: "#000000",
          gradient_color: "#000000",
          marker_out_color: "#000000",
          marker_in_color: "#000000",
          marker_top_right_outline: "#000000",
          marker_top_right_center: "#000000",
          marker_bottom_left_outline: "#000000",
          marker_bottom_left_center: "#000000",
          framecolor: "#000000",
          optionlogo: "none",
          "logo-size": 100,
          marker: "default",
          marker_in: "default",
          outer_frame: "none",
          framelabel: "SCAN ME",
          label_font: "AbrilFatface.svg",
          "label-text-size": 100,
          size: "248",
          level: "M",
        },
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("qr/template", {
          qr: obj,
          type: "visitCard",
          title: this.cardTexts.visitName,
        })
        .then(({ data }) => {
          this.finish = final;
          this.loading = false;
          this.$toast.success("مدل کارت ویزیت شما با موفقیت ساخته شد.");
          this.$router.replace({ name: "modelsList" });
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearDefaults() {
      this.$root.$emit("clearDefaultData");
      this.cardTexts.visitName = "";
      this.cardTexts.isGradient = false;
      this.cardTexts.organizationName = "";
      this.cardTexts.subOrgan = "";
      this.cardTexts.userName = "";
      this.cardTexts.workField = "";
      this.cardTexts.phoneNumber = [{ number: "" }];
      this.cardTexts.extraFields = [
        {
          icon: "",
          name: "",
          value: "",
        },
      ];
      this.cardTexts.companyNumber = "";
      this.cardTexts.email = "";
      this.cardTexts.fax = "";
      this.cardTexts.location = "";
      this.cardTexts.city = "";
      this.cardTexts.photo = {
        profile: "",
        transition: "scale",
        hasWelcome: false,
        hasGif: false,
        hasGame: false,

        previewerQr: {
          previewer: {
            gif: "",
            game: {},
            transition: "scale",
          },
        },
      };
      this.cardTexts.codePostal = "";
      this.cardTexts.province = "";
      this.cardTexts.country = "";
      this.cardTexts.website = "";
      this.cardTexts.socialMedia = {};
      this.cardTexts.aboutUs = "";
      this.cardTexts.video_single = {
        name: "",
        videos: [],
      };
      this.cardTexts.center = [51.420296, 35.732379];
      this.cardTexts.coordinates = null;
      this.cardTexts.address = "";
      this.cardTexts.apiKey =
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg";
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
